export default {
      id: "ic_arrow-up-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "img/icons.svg#ic_arrow-up",
      toString: function () {
        return this.url;
      }
    }